import { createRoot } from 'react-dom/client';
import './styles/global.scss';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store/store';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './Auth/authConfig';

const rootElement = document.getElementById('root');
const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <App />
        <ToastContainer autoClose={3000} />
      </Provider>
    </MsalProvider>
  );
}
